var React = require('react');

function Speaker (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.375 16.125V26.875H12.5417L21.5 35.8333V7.16663L12.5417 16.125H5.375ZM29.5625 21.5C29.5625 18.3287 27.735 15.6054 25.0833 14.2795V28.7025C27.735 27.3946 29.5625 24.6712 29.5625 21.5ZM25.0833 5.78705V9.47788C30.2612 11.0187 34.0417 15.8204 34.0417 21.5C34.0417 27.1795 30.2612 31.9812 25.0833 33.522V37.2129C32.2679 35.5825 37.625 29.1683 37.625 21.5C37.625 13.8316 32.2679 7.41746 25.0833 5.78705Z","fill":"currentColor"}));
}

Speaker.defaultProps = {"viewBox":"0 0 43 43","fill":"none"};

module.exports = Speaker;

Speaker.default = Speaker;
